import './header.css';
import logo from '../../assets/images/logo.svg';
import {NavLink, redirect, useNavigate} from "react-router-dom";
import AppContext from "../../contexts/appContext/app.context";
import {useContext, useEffect, useState} from "react";
import {decodeToken} from "react-jwt";
import LoginService from "../../services/login.service";
const userDetails: string = localStorage.getItem("user-details") || '';

const Header = () => {
    const [user, setUser] = useState({userDetails: {userName: ''}});
    const isActive = ({isActive}: any) => isActive ? 'active' : '';
    const isContain = (state: any) => {
        return '';
    };
    const appCtx = useContext(AppContext);
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);


    const hideMenu = () => {
        setShowMenu(false);
    }
    const toggleShowMenu = () => {
        const isShowMenu = showMenu;
        setShowMenu(!isShowMenu)
    }
    const handleLogout = () => {
        appCtx.doLogout();
        setShowMenu(false);
        navigate("");
    }
    const getUserDetails = async () => {
        const userDetails = await LoginService.getUserDetails();
        // console.log(userDetails);
        setUser(userDetails);
    }

    useEffect(() => {
        getUserDetails();
    }, [])

    return (
        <>
            <header>
                <div className="content-section flex hr-space-between">
                    <div className="logo flex gap-10">
                        <div className="icon logo-icon">
                            <img src={logo} alt=""/>
                        </div>
                        <div className="sf-bold font-16">
                            Onboard Fleet<br/> Services
                        </div>
                    </div>

                    <nav className={'flex gap-0 grey-color sf-medium font-15'}>
                        <NavLink to={'dashboard'} className={isActive}>Dashboard</NavLink>
                        <NavLink to={'trips'} className={isActive}>Trips</NavLink>
                        <NavLink to={'liveTrack'} className={isActive}>Live Track</NavLink>
                        <NavLink to={'drivers'} className={isActive}>Drivers</NavLink>
                        {/*<NavLink to={'vehicles'} className={isActive}>Vehicles</NavLink>*/}
                        <NavLink to={'videoTelematics/criticalAlerts'} className={isContain}>Video Telematics</NavLink>
                        <a>Reports</a>
                        <a>Settings</a>
                        {/*<div className={'flex gap-20'}>*/}
                        {/*    <div className="">John</div>*/}
                        {/*    <div className="icon width-12"><img src={downArrow} alt=""/></div>*/}
                        {/*</div>*/}
                        <div className="drop-down round-corner-12 transparent width-150">
                            <div className="drop-down-header">
                                <div className={'drop-down-title flex gap-20'}>
                                    {user?.userDetails?.userName}
                                </div>
                            </div>
                            <div className="drop-down-content">
                                <ul className="drop-down-list line-40">
                                    <li className={'cursor-pointer'} onClick={handleLogout}>Logout</li>
                                </ul>
                            </div>
                        </div>
                    </nav>

                    <ul className={`app-menu-btn ${showMenu ? 'animate' : ''}`}
                        onClick={toggleShowMenu}>
                        <li className="top"></li>
                        <li className="mid"></li>
                        <li className="low"></li>
                    </ul>
                </div>
            </header>


            <div className={`menuSec ${showMenu ? 'show' : ''}`}>
                <div className="menuCont">
                    <ul className="menuList grey-color sf-medium font-15">
                        <li onClick={hideMenu}><NavLink to={'dashboard'} className={isActive}>Dashboard</NavLink></li>
                        <li onClick={hideMenu}><NavLink to={'trips'} className={isActive}>Trips</NavLink></li>
                        <li onClick={hideMenu}><NavLink to={'liveTrack'} className={isActive}>Live Track</NavLink></li>
                        <li onClick={hideMenu}><NavLink to={'drivers'} className={isActive}>Drivers</NavLink></li>
                        {/*<NavLink to={'vehicles'} className={isActive}>Vehicles</NavLink>*/}
                        <li onClick={hideMenu}><NavLink to={'videoTelematics'} className={isActive}>Video Telematics</NavLink></li>
                        <li onClick={hideMenu}><a>Reports</a></li>
                        <li onClick={hideMenu}><a>Settings</a></li>
                        <li className={'cursor-pointer'} onClick={handleLogout}>Logout</li>
                    </ul>
                </div>
            </div>
        </>


    )
}

export default Header;
